// Open-Meteo (https://open-meteo.com) - free, open-source, no API key/signup required, and CORS-
// friendly enough to call directly from the browser. Used to prefill a newly-placed weather
// widget with the user's actual local conditions instead of a static mock, while still leaving
// both temperature and emoji manually editable afterwards (see OverlayConfigPanel.vue).

// WMO weather interpretation codes (the standard Open-Meteo's current_weather returns) mapped to
// the closest single emoji - https://open-meteo.com/en/docs#weathervariables
const WEATHER_CODE_EMOJI = {
    0: '☀️',
    1: '🌤️',
    2: '⛅',
    3: '☁️',
    45: '🌫️',
    48: '🌫️',
    51: '🌦️',
    53: '🌦️',
    55: '🌦️',
    56: '🌧️',
    57: '🌧️',
    61: '🌧️',
    63: '🌧️',
    65: '🌧️',
    66: '🌧️',
    67: '🌧️',
    71: '🌨️',
    73: '🌨️',
    75: '🌨️',
    77: '🌨️',
    80: '🌦️',
    81: '🌧️',
    82: '⛈️',
    85: '🌨️',
    86: '🌨️',
    95: '⛈️',
    96: '⛈️',
    99: '⛈️'
}

export const weatherCodeToEmoji = (code) => WEATHER_CODE_EMOJI[code] || '☀️'

const getPosition = (timeoutMs) => new Promise((resolve, reject) => {
    if (!navigator.geolocation) { reject(new Error('Geolocation unsupported')); return }
    navigator.geolocation.getCurrentPosition(resolve, reject, { timeout: timeoutMs, maximumAge: 10 * 60 * 1000 })
})

// Best-effort only - resolves to null (never rejects) on any failure: permission denied, no
// geolocation support, network error, timeout. A placement can always fall back to the static
// mock instead of ever getting stuck waiting on this.
export const fetchCurrentWeather = async (timeoutMs = 4000) => {
    try {
        const position = await getPosition(timeoutMs)
        const { latitude, longitude } = position.coords
        const url = `https://api.open-meteo.com/v1/forecast?latitude=${latitude}&longitude=${longitude}&current_weather=true`
        const response = await fetch(url)
        if (!response.ok) return null
        const json = await response.json()
        const current = json.current_weather
        if (!current || typeof current.temperature !== 'number') return null
        return { temperature: Math.round(current.temperature), unit: 'celsius', emoji: weatherCodeToEmoji(current.weathercode) }
    } catch (e) {
        return null
    }
}
